{
  "ru": {
    "paymentErrorsModals": {
      "paymentExpired": {
        "title": {
          "base": "Время для {paymentType} истекло",
          "payment": "оплаты",
          "surcharge": "доплаты"
        },
        "description": {
          "base": "Пожалуйста, попробуйте заново создать {orderType} или обратитесь в службу поддержки",
          "order": "заказ",
          "surcharge": "заявку"
        }
      },
      "default": {
        "title": {
          "base": "Произошла ошибка при загрузке {orderType}",
          "order": "заказа",
          "surcharge": "доплаты"
        },
        "description": "Пожалуйста, попробуйте заново или обратитесь в службу поддержки"
      },
      "paid": {
        "title": "Заказ уже оплачен",
        "surchargeTitle": "Доплата оплачена",
        "description": "Пройдите в личный кабинет, чтобы посмотреть ваш заказ",
        "proceedToOrder": "Перейти к заказу"
      },
      "pay": {
        "title": "Произошла ошибка при оплате",
        "description": "Пожалуйста, попробуйте заново или обратитесь в службу поддержки"
      },
      "retry": "Попробовать заново",
      "returnToOrder": "Вернуться к заказу",
      "startNewSearch": "Начать новый поиск",
      "backToMain": "Вернуться на главную"
    }
  },
  "kk": {
    "paymentErrorsModals": {
      "paymentExpired": {
        "title": {
          "base": "{paymentType} берілген уақыт аяқталды",
          "payment": "Төлеуге",
          "surcharge": "Қосымша ақыны төлеуге"
        },
        "description": {
          "base": "Қайтадан {orderType} беріп көріңіз немесе қолдау қызметіне хабарласыңыз",
          "order": "тапсырыс",
          "surcharge": "өтінім"
        }
      },
      "default": {
        "title": {
          "base": "{orderType} кезінде қате кетті",
          "order": "Төлеу",
          "surcharge": "Қосымша ақыны төлеу"
        },
        "description": "Қайталап көріңіз немесе қолдау қызметіне хабарласыңыз"
      },
      "paid": {
        "title": "Тапсырыс төленген",
        "surchargeTitle": "Қосымша ақы төленді",
        "description": "Тапсырысыңызды көру үшін жеке кабинетке кіріңіз",
        "proceedToOrder": "Тапсырысқа өту"
      },
      "pay": {
        "title": "Төлеу кезінде қате кетті",
        "description": "Қайталап көріңіз немесе қолдау қызметіне хабарласыңыз"
      },
      "retry": "Қайталап көру",
      "returnToOrder": "Тапсырысқа қайту",
      "startNewSearch": "Жаңадан іздеу",
      "backToMain": "Басты бетке өту"
    }
  },
  "en": {
    "paymentErrorsModals": {
      "paymentExpired": {
        "title": {
          "base": "Time for {paymentType} has expired",
          "payment": "payment",
          "surcharge": "surcharge"
        },
        "description": {
          "base": "Please try to create {orderType} again or contact support",
          "order": "order",
          "surcharge": "request"
        }
      },
      "default": {
        "title": {
          "base": "An error occurred while loading {orderType}",
          "order": "order",
          "surcharge": "surcharge"
        },
        "description": "Please try again or contact support"
      },
      "paid": {
        "title": "Order already paid",
        "surchargeTitle": "Surcharge paid",
        "description": "Go to your personal account to view your order",
        "proceedToOrder": "Proceed to order"
      },
      "pay": {
        "title": "An error occurred while paying",
        "description": "Please try again or contact support"
      },
      "retry": "Try again",
      "returnToOrder": "Return to order",
      "startNewSearch": "Start a new search",
      "backToMain": "Return to main"
    }
  }
}
